import DashboardLayout from '@/views/Layout/DashboardLayout.vue';

const CampaignsList = () => import(/* webpackChunkName: "campaigns" */ '@/views/Campaigns/List.vue');
const CampaignCreate = () => import(/* webpackChunkName: "campaigns" */ '@/views/Campaigns/Create.vue');
const CampaignEdit = () => import(/* webpackChunkName: "campaigns" */ '@/views/Campaigns/Edit.vue');
const CampaignDates = () => import(/* webpackChunkName: "campaigns" */ '@/views/Campaigns/Dates.vue');

let campaignsPages = {
  path: '/campaigns',
  redirect: '/campaigns',
  component: DashboardLayout,
  name: 'Campaigns',
  meta: {
    title: 'Campañas',
    auth: true,
  },
  children: [
    {
      path: '',
      name: 'CampaignsList',
      meta: {
        title: 'Listado',
        auth: ['campaigns.index'],
      },
      component: CampaignsList,
    },
    {
      path: 'create',
      name: 'CampaignCreate',
      meta: {
        title: 'Nueva',
        auth: ['campaigns.store'],
      },
      component: CampaignCreate,
    },
    {
      path: ':id/edit',
      name: 'CampaignEdit',
      meta: {
        title: 'Editar',
        auth: ['campaigns.update'],
      },
      component: CampaignEdit,
    },
    {
      path: ':id/dates',
      name: 'CampaignDates',
      meta: {
        title: 'Cargar fechas de Campaña',
        //auth: ["campaign_dates.index"]
      },
      component: CampaignDates,
    },
  ],
};

export default campaignsPages;
